module.exports = __webpack_public_path__ + "img/jinchu.08033056.png";